import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'addSpaces',
    standalone: false
})
export class AddSpacesPipe implements PipeTransform {
   transform(spacedString: string): string {
      return addSpacesToTypeName(spacedString);
   }
}

export function addSpacesToTypeName(value: string): string {
   if (typeof value !== 'string') return '';

   return value
      .replace(/([a-z])([A-Z])/g, '$1 $2') // camelCase → camel Case
      .replace(/([A-Za-z])([0-9])/g, '$1 $2') // letter → number
      .replace(/([0-9])([A-Za-z])/g, '$1 $2') // number → letter
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2'); // acronym → word
}
